module.exports = __webpack_public_path__ + "img/icon_orthopaedie.4d173ea5.svg";